<script>
import _ from 'lodash'
import { exportTemplateAsCSV as createCsv } from '../../../utils/fileUtils'
import { getAllData } from '../../../utils/indexedDbUtils'
import { toggleInArray } from '../../../utils/utils'
import Card from '../../../slds/Card'
import FilePicker from '../../../slds/FilePicker'
import Modal from '../../../Modal'
import Spinner from '../../../Spinner'
import TabSet from '../../../slds/tabs/TabSet'
import Tab from '../../../slds/tabs/Tab'

export default {
  components: {
    Tab,
    TabSet,
    Card,
    FilePicker,
    Modal,
    Spinner
  },
  props: {
    brands: Array,
    canExcludeVin: Boolean,
    editable: Boolean,
    informativeCampaign: Boolean,
    mvs: Object,
    mvsToExclude: Object,
    vin: [ Array, Object ],
    vinToExclude: [ Array, Object ]
  },
  async created () {
    this.openTab = this.mvs && Object.keys(this.mvs).length ? 'MVS' : 'VIN'

    this.mvsInvertedMap = (await getAllData('mvs')).reduce((acc, val) => {
      acc[val.mvs] = val
      return acc
    }, {})

    this.localMvs = _.cloneDeep(this.mvs)
    this.localMvsToExclude = _.cloneDeep(this.mvsToExclude)
    this.localVin = _.cloneDeep(this.vin)
    this.localVinToExclude = _.cloneDeep(this.vinToExclude)
  },
  data () {
    return {
      localMvs: {},
      localMvsToExclude: {},
      localVin: {},
      localVinToExclude: {},
      mvsInvertedMap: {},
      openTab: ''
    }
  },
  methods: {
    clearMVS (brand) {
      this.localMvs[brand] = []
    },
    downloadTemplate (template) {
      const type = template.toUpperCase()
      createCsv(`EMPTY_${type}_CSV`, `TEMPLATE_${type}.csv`)
    },
    async handleExcludedVINUpload (event) {
      const { content } = event

      try {
        const vinList = content.split(/\r?\n/)
        if (!this.localVinToExclude) {
          this.localVinToExclude = [...vinList]
        } else {
          this.localVinToExclude.push(...vinList)
        }
      } catch (error) {
        console.error(error)
        this.showToast('error', this.$t('general.error'), 'text', error)
      }
    },
    async handleIncludedVINMVSUpload (event, filterType) {
      const { content } = event

      try {
        if (filterType === 'mvs') {
          if (!this.localMvs) {
            this.localMvs = {}
            if (this.selectedBrands[0] === 'All') {
              this.brands.forEach(brand => {
                this.localMvs[brand.value] = []
              })
            } else {
              this.selectedBrands.forEach(brand => {
                this.localMvs[brand.value] = []
              })
            }
          } else {
            if (Object.keys(this.localMvs).length === 1 && 'All' in this.localMvs) {
              this.brands.forEach(brand => {
                this.localMvs[brand.value] = []
              })
            }
          }

          const mvsList = content.split(/\r?\n/)
          const mvsNotFound = []
          mvsList.forEach(mvs => {
            if (mvs.trim().length > 0) {
              const mvsObject = this.mvsInvertedMap[mvs.trim()]
              if (mvsObject && this.localMvs[mvsObject.brand]) {
                this.localMvs[mvsObject.brand].push(mvs.trim())
              } else {
                mvsNotFound.push(`<li>- ${mvs}</li>`)
              }
            }
          })

          if (mvsNotFound.length > 0) {
            this.showToast('warning',
              this.$t('campaignDesigner.targetDefinition.mvsNotFoundWarning'),
              'HTML',
              this.$t('campaignDesigner.targetDefinition.mvsNotFoundWarningText', { list: mvsNotFound.join('') }))
          } else {
            this.showToast('success', this.$t('general.success'), 'text', this.$t('message.update'))
          }

          this.$forceUpdate()
        } else {
          const vinList = content.split(/\r?\n/).filter(v => !!v)
          if (!this.localVin) {
            this.localVin = vinList
          } else {
            this.localVin.push(...vinList)
          }
          // Removed duplicates
          this.localVin = Array.from(new Set(this.localVin))
        }
      } catch (error) {
        console.error(error)
        this.showToast('error', this.$t('general.error'), 'text', error)
      }
    },
    async handleExcludedMVSUpload (event) {
      const { content } = event

      if (!this.localMvsToExclude) {
        this.localMvsToExclude = {}
        if (this.selectedBrands[0] === 'All') {
          this.brands.forEach(brand => {
            this.localMvsToExclude[brand.value] = []
          })
        } else {
          this.selectedBrands.forEach(brand => {
            this.localMvsToExclude[brand.value] = []
          })
        }
      } else {
        if (Object.keys(this.localMvsToExclude).length === 1 && 'All' in this.localMvsToExclude) {
          this.brands.forEach(brand => {
            this.localMvsToExclude[brand.value] = []
          })
        }
      }

      const mvsList = content.split(/\r?\n/)
      const mvsNotFound = []
      mvsList.forEach(mvs => {
        if (mvs.trim().length > 0) {
          const mvsObject = this.mvsInvertedMap[mvs.trim()]
          if (mvsObject && this.localMvsToExclude[mvsObject.brand]) {
            if (!this.localMvsToExclude[mvsObject.brand].includes(mvs.trim())) {
              this.localMvsToExclude[mvsObject.brand].push(mvs.trim())
            }
          } else {
            mvsNotFound.push(`<li>- ${mvs}</li>`)
          }
        }
      })

      if (mvsNotFound.length > 0) {
        this.showToast('warning',
          this.$t('campaignDesigner.targetDefinition.mvsNotFoundWarning'),
          'HTML',
          this.$t('campaignDesigner.targetDefinition.mvsNotFoundWarningText', { list: mvsNotFound.join('') }))
      } else {
        this.showToast('success', this.$t('general.success'), 'text', this.$t('message.update'))
      }

      this.$forceUpdate()
    },
    removeMvs (brand, mvs) {
      toggleInArray(this.localMvs[brand.value], mvs)
    },
    removeMvsToExclude (brand, mvs) {
      toggleInArray(this.localMvsToExclude[brand.value], mvs)
    },
    removeVin (vin) {
      toggleInArray(this.localVin, vin)
    },
    removeVinToExclude (vin) {
      toggleInArray(this.localVinToExclude, vin)
    },
    save () {
      this.$emit('save', {
        data: {
          mvs: _.cloneDeep(this.localMvs),
          mvsToExclude: _.cloneDeep(this.localMvsToExclude),
          vin: _.cloneDeep(this.localVin),
          vinToExclude: _.cloneDeep(this.localVinToExclude)
        }
      })
    }
  },
  computed: {
    userCanIncludeMVS () {
      if (this.editable) {
        if (this.informativeCampaign) {
          return true
        } else {
          return Object.values(this.localMvs).flat().length === 0
        }
      } else {
        return false
      }
    }
  },
  watch: {
    mvs (val) {
      this.localMvs = _.cloneDeep(val)
    },
    mvsToExclude (val) {
      this.localMvsToExclude = _.cloneDeep(val)
    },
    vin (val) {
      this.localVin = _.cloneDeep(val)
    },
    vinToExclude (val) {
      this.localVinToExclude = _.cloneDeep(val)
    }
  }
}
</script>
<template>
  <Modal
    directional
    @close="$emit('close')"
    :height="localMvs && Object.keys(localMvs).length ? '90vh' : '40vh'"
    :title="$t(`campaignDesigner.targetDefinition.manageMvsVin`)">

    <Spinner v-if="!(Object.keys(mvsInvertedMap) && Object.keys(mvsInvertedMap).length)" />

    <TabSet tab-set-id="manage_vin_mvs" v-else>
      <Tab :label="$t('campaignDesigner.targetDefinition.mvs')" tab-set-id="manage_vin_mvs">
        <!-- Included MVS -->
        <Card additional-classes="slds-card_boundary height-reset" :title="$t('campaignDesigner.targetDefinition.includedMVS')">
          <div class="slds-button-group" role="group" v-if="userCanIncludeMVS" slot="actions">
            <FilePicker accept="text/csv" :label="$t('action.upload')" @load="handleIncludedVINMVSUpload($event, 'mvs')" />
            <button class="slds-button slds-button_neutral" @click="downloadTemplate('mvs')">{{$t('campaignDesigner.targetDefinition.downloadTemplate')}}</button>
          </div>

          <Card
            :key="brand.value"
            :show-body="!!(localMvs && localMvs[brand.value] && localMvs[brand.value].length)"
            :title="`${brand.description} (${localMvs[brand.value] ? localMvs[brand.value].length : 0})`"
            additional-classes="slds-card_boundary height-reset"
            v-for="brand in brands">

            <div class="slds-button-group" role="group" v-if="editable" slot="actions">
              <button class="slds-button slds-button_neutral" @click="clearMVS(brand.value)" v-if="localMvs[brand.value] && localMvs[brand.value].length">{{$t('campaignDesigner.targetDefinition.clear')}}</button>
            </div>

            <ul class="slds-listbox slds-listbox_horizontal" role="listbox" aria-orientation="horizontal">
              <template v-for="(mvs, index) in localMvs[brand.value]">
                <li class="slds-listbox-item" role="presentation"  :key="index">
                  <span class="slds-pill" role="option" :tabindex="index" aria-selected="true">
                    <span class="slds-pill__label">{{mvsInvertedMap[mvs].mvs}} - {{mvsInvertedMap[mvs].label}}</span>
                    <span class="slds-icon_container slds-pill__remove" :title="$t('action.remove')" @click="removeMvs(brand, mvs)" v-if="editable && (informativeCampaign || localMvs[brand.value].length > 1)">
                      <svg class="slds-icon slds-icon_x-small slds-icon-text-default" aria-hidden="true">
                        <use xlink:href="../../../../assets/symbols.svg#close"></use>
                      </svg>
                    </span>
                  </span>
                </li>
              </template>
            </ul>
          </Card>
        </Card>

        <!-- Excluded MVS -->
        <Card additional-classes="slds-card_boundary height-reset"
          :title="$t('campaignDesigner.targetDefinition.excludedMVS')">
          <div class="slds-button-group" role="group" v-if="editable" slot="actions">
            <FilePicker accept="text/csv" :label="$t('action.upload')" @load="handleExcludedMVSUpload" />
            <button class="slds-button slds-button_neutral" @click="downloadTemplate('mvs')">{{$t('campaignDesigner.targetDefinition.downloadTemplate')}}</button>
          </div>

          <Card
            :key="brand.value"
            :show-body="!!(localMvsToExclude && localMvsToExclude[brand.value] && localMvsToExclude[brand.value].length)"
            :title="`${brand.description} (${localMvsToExclude[brand.value] ? localMvsToExclude[brand.value].length : 0})`"
            additional-classes="slds-card_boundary height-reset"
            v-for="brand in brands">

            <ul class="slds-listbox slds-listbox_horizontal" role="listbox" aria-orientation="horizontal">
              <template v-for="(mvs, index) in localMvsToExclude[brand.value]">
                <li class="slds-listbox-item" role="presentation"  :key="index">
                  <span class="slds-pill" role="option" :tabindex="index" aria-selected="true">
                    <span class="slds-pill__label">{{mvsInvertedMap[mvs].mvs}} - {{mvsInvertedMap[mvs].label}}</span>
                    <span class="slds-icon_container slds-pill__remove" :title="$t('action.remove')" @click="removeMvsToExclude(brand, mvs)" v-if="editable">
                      <svg class="slds-icon slds-icon_x-small slds-icon-text-default" aria-hidden="true">
                        <use xlink:href="../../../../assets/symbols.svg#close"></use>
                      </svg>
                    </span>
                  </span>
                </li>
              </template>
            </ul>

          </Card>
        </Card>
      </Tab>
      <Tab :label="$t('campaignDesigner.targetDefinition.vin')" tab-set-id="manage_vin_mvs">
        <!-- Included VIN -->
        <Card
          additional-classes="slds-card_boundary height-reset"
          :title="$t('campaignDesigner.targetDefinition.includedVIN', {count: localVin ? localVin.length : 0})"
          :show-body="!!(localVin && localVin && localVin.length)">

          <div class="slds-button-group" role="group" v-if="editable && informativeCampaign" slot="actions">
            <FilePicker accept="text/csv" :label="$t('action.upload')" @load="handleIncludedVINMVSUpload($event, 'vin')" />
            <button class="slds-button slds-button_neutral" @click="downloadTemplate('vin')">{{$t('campaignDesigner.targetDefinition.downloadTemplate')}}</button>
          </div>

          <ul class="slds-listbox slds-listbox_horizontal" role="listbox" aria-label="Selected Options:" aria-orientation="horizontal" >
            <li class="slds-listbox-item" role="presentation" v-for="(v, index) in localVin" :key="index">
              <span class="slds-pill" role="option" :tabindex="index" aria-selected="true">
                <span class="slds-pill__label">{{v}}</span>
                <span class="slds-icon_container slds-pill__remove" :title="$t('action.remove')" @click="removeVin(v)" v-if="editable && (informativeCampaign || localVin.length > 1)">
                  <svg class="slds-icon slds-icon_x-small slds-icon-text-default" aria-hidden="true">
                    <use xlink:href="../../../../assets/symbols.svg#close"></use>
                  </svg>
                </span>
              </span>
            </li>
          </ul>
        </Card>

        <!-- Excluded VIN -->
        <Card additional-classes="slds-card_boundary height-reset"
          :title="$t('campaignDesigner.targetDefinition.excludedVIN', {count: localVinToExclude ? localVinToExclude.length : 0})">
          <div class="slds-button-group" role="group" v-if="canExcludeVin && editable" slot="actions">
            <FilePicker accept="text/csv" :label="$t('action.upload')" @load="handleExcludedVINUpload" />
            <button class="slds-button slds-button_neutral" @click="downloadTemplate('vin')">{{$t('campaignDesigner.targetDefinition.downloadTemplate')}}</button>
          </div>
          <ul class="slds-listbox slds-listbox_horizontal slds-m-top--medium" role="listbox" aria-orientation="horizontal" v-if="localVinToExclude && localVinToExclude.length">
            <li class="slds-listbox-item" role="presentation" v-for="(vin, index) in localVinToExclude" :key="index">
              <span class="slds-pill" role="option" :tabindex="index" aria-selected="true">
                <span class="slds-pill__label">{{vin}}</span>
                <span class="slds-icon_container slds-pill__remove" :title="$t('action.remove')" @click="removeVinToExclude(vin)" v-if="canExcludeVin && editable">
                  <svg class="slds-icon slds-icon_x-small slds-icon-text-default" aria-hidden="true">
                    <use xlink:href="../../../../assets/symbols.svg#close"></use>
                  </svg>
                </span>
              </span>
            </li>
          </ul>
        </Card>
      </Tab>
    </TabSet>

    <template slot="footer" v-if="editable">
      <button class="slds-button slds-button_neutral" @click="$emit('close')">{{$t('action.cancel')}}</button>
      <button class="slds-button slds-button_brand" @click="save">{{$t('action.save')}}</button>
    </template>
  </Modal>
</template>
<style lang="scss" scoped>
  svg {
    cursor: pointer;
  }
</style>
